<template>
    <section>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-6">
                            <h2>
                               Regions
                            </h2>
                        </div>
                        <div class="col-md-6 text-right">
                           <a :href="$laravelRoute('regions.create')" class="btn btn-default">Add New Region</a>
                        </div>

                    </div>

                    <div v-if="total > 0">
                        <strong>Showing</strong>
                        <span>{{ from }}</span>-<span>{{ to }}</span> of <span>{{ total }}</span>
                        results
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <b-table
                                    class="list-table"
                                    :sort-by.sync="sort_by"
                                    :sort-desc.sync="sort_desc"
                                    :fields="fields"
                                    :items="regions"
                                    show-empty
                            >
                                <template v-slot:empty="scope">
                                    No data is available...
                                </template>
                                <template v-slot:cell(action)="data">
                                    <div><a :href="$laravelRoute('regions.edit', data.item.id)">Edit</a> </div>
                                </template>
                                <template v-slot:cell(enabled)="data">
                                    <i class="fa fa-check text-success" v-if="data.item.enabled"></i>
                                    <i class="fa fa-times text-danger" v-else></i>
                                </template>
                            </b-table>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">&nbsp;</div>
                    </div>
                    <b-pagination
                        v-if="total > 0"
                        :total-rows="total"
                        v-model="current_page"
                        :per-page="per_page"
                    ></b-pagination>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import { mapState, mapActions } from 'vuex'
    import {objLookup} from '../../util/common'
    export default {
        created(){
            this.$store.dispatch('region/getRegions', {
                sort_by: this.sortBy,
                sort_desc: this.sortDesc,
            });
        },
        data() {
            return {
                sort_by: 'name',
                sort_desc: true,
                selected_search: null,
                fields: [
                    {label: 'Enabled', key: 'enabled',},
                    {label: 'Name', key: 'name',},
                    {label: 'Currency', key: 'currency_code',},
                    {label: 'Note', key: 'note',},
                    {label: 'Action', key: 'action',},
                ],
            }
        },
        computed: {
            ...mapState({
                regions: state => state.region.all,
                per_page: state => state.region.per_page,
                from: state => state.region.from,
                to: state => state.region.to,
                last_page: state => state.region.last_page,
                total: state => state.region.total,
            }),
            current_page: {
                get(){
                    return this.$store.getters['region/getRegions'];
                },
                set(value){
                    return this.$store.dispatch('region/getRegions', {page: value});
                }
            }
        },
        methods: {
            objLookup(obj, key){
                return objLookup(obj, key);
            },
        }
    }

</script>



// WEBPACK FOOTER //
// resources/js/components/region/ListPage.vue